<template>
  <div class="Copyright">
    <div class="container">
      <Social />
      <p class="copyright-text">&copy; Copyright 2019 Art Transplant</p>
    </div>
  </div>
</template>
<script>
import Social from '../components/Social';

export default {
  name: 'Copyright',
  components: {
    Social
  },
  computed: {
  },
  mounted () {
  },
  data () {
    return {
    };
  }
};
</script>
<style lang='scss' scoped>
@import '../scss/colors.scss';

  .Copyright {
    padding: 30px 20px;
    background: $darkestGrey;
    color: $white;

    .container {
        display: flex;
        align-items: center;
    }

    .Social {
      flex: 1 1 auto;
    }

    .copyright-text {
      flex: 0 1 auto;
      font-size: 0.7em;
    }
  }
</style>
